import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from '../common-data-model';
import { BoxContainerService } from 'src/app/box-container/box-container.service';
import { MatDialog } from '@angular/material';
import { ContainerModifiersLaborBreakUpComponent } from '../container-modifiers-labor-break-up/container-modifiers-labor-break-up.component';
import { LabourMethodTypeEnum } from '../app-common-enum';
import * as _ from 'lodash';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-container-summary',
    templateUrl: './container-summary.component.html',
    styleUrls: ['./container-summary.component.scss']
})

export class ContainerSummaryComponent implements OnInit {
    @ViewChild('containerSummaryGeneralForm', { static: false }) containerSummaryGeneralForm: NgForm;
    @ViewChild('containerLaborCalculationForm', { static: false }) containerLaborCalculationForm: NgForm;
    @ViewChild('optionsLaborCalculationForm', { static: false }) optionsLaborCalculationForm: NgForm;
    @ViewChild('containerLaborTotalsForm', { static: false }) containerLaborTotalsForm: NgForm;

    @Input() set containerIdParam(containerId: any) {
        if (containerId) {
            this.getContainerSummary(containerId);
            this.containerId = containerId;
        }
    }

    @Input() readOnly: boolean;
    @Output() emitUpdateContainerSummary: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private commonService: CommonService,
        private boxContainerServices: BoxContainerService,
        public dialog: MatDialog,
    ) { }

    labourMethodTypeEnum: typeof LabourMethodTypeEnum = LabourMethodTypeEnum;
    containerId: number;
    costMethods: Array<any>;
    commonDataModel = new CommonDataModel();
    containerSummary = this.commonDataModel.containerDimentionsModel;

    ngOnInit() {
        this.boxContainerServices.getLaborMethodLookUp().subscribe(response => {
            this.costMethods = response.data;
        });
    }

    getContainerSummary(containerId: any) {
        this.commonService.getContainerSummary(containerId).subscribe((response: any) => {
            if (response.data) {
                this.containerSummary = _.cloneDeep(response.data);
                this.formatCostData();
            } else {
                this.containerSummary = null;
            }
            this.emitUpdateContainerSummary.emit(false);
        });
    }

    formatCostData() {
        this.containerSummary.itemContainerSummary.fastenerCost = parseFloat(this.containerSummary.itemContainerSummary.fastenerCost.toFixed(2));
        this.containerSummary.itemContainerSummary.totalMaterialCost = parseFloat(this.containerSummary.itemContainerSummary.totalMaterialCost.toFixed(2));
        this.containerSummary.laborCalculation.volumeLabor = parseFloat(this.containerSummary.laborCalculation.volumeLabor.toFixed(2));
        this.containerSummary.laborCalculation.cutsLinearLabor = parseFloat(this.containerSummary.laborCalculation.cutsLinearLabor.toFixed(2));
        this.containerSummary.laborCalculation.modifiersLaborCost = parseFloat(this.containerSummary.laborCalculation.modifiersLaborCost.toFixed(2));
        this.containerSummary.modifiersLaborCalculation.volumeLabor = parseFloat(this.containerSummary.modifiersLaborCalculation.volumeLabor.toFixed(2));
        this.containerSummary.modifiersLaborCalculation.cutsLinearLabor = parseFloat(this.containerSummary.modifiersLaborCalculation.cutsLinearLabor.toFixed(2));
        this.containerSummary.modifiersLaborCalculation.modifiersLaborCost = parseFloat(this.containerSummary.modifiersLaborCalculation.modifiersLaborCost.toFixed(2));
        this.containerSummary.itemContainerLabor.containerLaborCost = parseFloat(this.containerSummary.itemContainerLabor.containerLaborCost.toFixed(2));
        this.containerSummary.itemContainerLabor.prepLaborCost = parseFloat(this.containerSummary.itemContainerLabor.prepLaborCost.toFixed(2));
        this.containerSummary.itemContainerLabor.minimumLabor = parseFloat(this.containerSummary.itemContainerLabor.minimumLabor.toFixed(2));
        this.containerSummary.itemContainerLabor.totalLaborCost = parseFloat(this.containerSummary.itemContainerLabor.totalLaborCost.toFixed(2));
    }

    onEnableSaveButton(summaryObj?: any, type?: any) {
        if (summaryObj) {
            summaryObj.isChanged = true;
            summaryObj.isCustom = type == 'laborCalculation' ? true : summaryObj.isCustom;
        }
        this.emitUpdateContainerSummary.emit(true);
    }

    onContainerLaborCostChange() {
        this.containerSummary.itemContainerLabor.isChanged = true;
        this.containerSummary.itemContainerLabor.costMethodId = this.labourMethodTypeEnum.fixedLabor;
        this.emitUpdateContainerSummary.emit(true);
    }

    onCostMethodChange(event: any) {
        this.containerSummary.itemContainerLabor.isChanged = true;
        this.containerSummary.itemContainerLabor.costMethodId = event.laborMethodId;
        if (event.laborMethodId === this.labourMethodTypeEnum.fixedLabor) {
            this.containerSummary.itemContainerLabor.containerLaborCost = this.containerSummary.itemContainerLabor.customFixedLabour;
        }
        this.emitUpdateContainerSummary.emit(true);
    }

    onCushioningDetailsOpenDialog(): void {
        this.dialog.open(ContainerModifiersLaborBreakUpComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            data: this.containerId,
            autoFocus: false
        });
    }
}
